import { agentsType } from 'src/enumeration';
import * as yup from 'yup';
import errorsText from '../../../utils/errorsText';
import persianToEnglishNumber from '../../../utils/persianToEnglishNumber';

const fieldNames = {
  name: 'name',
  gender: 'gender',
  caravan_id: 'caravan_id',
  manager_id: 'manager_id',
  rohani_id: 'rohani_id',
  deputy_id: 'deputy_id',
  woman_rohani_id: 'woman_rohani_id',
  university_category_id: 'university_category_id',
  university_id: 'university_id',
  iran_province_id: 'iran_province_id',
  address: 'address',
  flight_station: 'flight_station',
  dispatch_date: 'date',
  period_from: 'period_from',
  period_to: 'period_to',
  meeting_date: 'meeting_date',
  baj_number: 'baj_number',
  capacity: 'capacity',
  agent_capacity: 'agent_capacity',
  storage_capacity: 'storage_capacity',
  storage_max: 'storage_max',
  price: 'price',
  border: 'border',
  border_code: 'border_code',
  is_lottery: 'is_lottery',
  team_type: 'team_type',
  team_grade: 'team_grade',
  interface_id: 'interface_id',
  status: 'status',
  active: 'active',
  travel_id: 'travel_id',
  socials: 'socials',
  link: 'link',
  social: 'social',
  teamSocialId: 'teamSocialId',
  agents: 'agents',
  agent: 'agent',
  admin: 'admin',
  men_count: 'men_count',
  women_count: 'women_count',
  married_count: 'married_count',
  triple_bed: 'triple_bed',
  double_bed: 'double_bed',
  single_bed: 'single_bed',
};

const validation = {
  defaultValue:{},
  fieldNames,
  schema: () =>
    yup.object().shape({
      [validation.fieldNames.dispatch_date]: yup.string().nullable().required(errorsText.blankError()),
      [validation.fieldNames.gender]: yup.mixed().required(errorsText.blankError()),
      [validation.fieldNames.iran_province_id]: yup.object().nullable().required(errorsText.blankError()),
    }),
};

export default validation;
